import { useHistory } from "react-router-dom";
import { MenuItem, useColorModeValue, Box } from "@chakra-ui/react";
import { RiShutDownLine } from "react-icons/all";

import { useLogoutUser } from "modules/authentication/infrastructure/useLogoutUser";
import { useLogoutNotification } from "modules/authentication/presentation/useLogoutNotification";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { Icon } from "components/Icon";
import { ChakraText } from "components/ChakraText";
import { Spinner } from "components/Spinner";
import { useGetThemeColors } from "ChakraTheme";

interface IProps {
  closeMenu: () => void;
}

const LogoutMenuItem = ({ closeMenu }: IProps) => {
  const { friendlyUrl } = useGetFriendlyUrl();
  const colors = useGetThemeColors();
  const history = useHistory();
  const color = useColorModeValue(colors.red[500], colors.red[200]);
  const logoutUser = useLogoutUser();
  const {
    showErrorNotification,
    showSuccessNotification,
  } = useLogoutNotification();

  return (
    <Box id="logged-user-menu-logout-btn">
      <MenuItem
        closeOnSelect={false}
        icon={
          logoutUser.isLoading ? (
            <Spinner mt={1} size="sm" />
          ) : (
            <Icon color={color} w={5} h={5} icon={RiShutDownLine} />
          )
        }
        onClick={async () => {
          try {
            await logoutUser.mutateAsync();
            closeMenu();
            history.push(`/e-rezerwacja/${friendlyUrl}`);
            showSuccessNotification();
          } catch {
            showErrorNotification();
          }
        }}
      >
        <ChakraText color={color}>Wyloguj</ChakraText>
      </MenuItem>
    </Box>
  );
};

export { LogoutMenuItem };
